<div #captchaTemp class="captcha">
  <app-captcha class="g-recaptcha"
              (onResolve)="resolved($event)" [size]="size === 'invisible' ? size : ''"
              [siteKey]="siteKey">
  </app-captcha>
  <!-- <small *ngIf="control?.hasError('required') && control.touched" class="error-message">Captcha validation is required</small> -->
  <small *ngIf="control?.hasError('required') && control.touched" class="error-message">Waiting for Captcha Verification...</small>
  <small *ngIf="control?.hasError('failed')" class="error-message">Captcha validation failed</small>
</div>
